// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"357":"347e4ee5","840":"1811ac38"}[chunkId] + ".chunk.css";
};